export let UserTabType;

(function (UserTabType) {
  UserTabType["Following"] = "following";
  UserTabType["Followers"] = "followers";
})(UserTabType || (UserTabType = {}));